import { render, staticRenderFns } from "./ModalAddRegras.vue?vue&type=template&id=5caa8046&scoped=true"
import script from "./ModalAddRegras.vue?vue&type=script&lang=ts"
export * from "./ModalAddRegras.vue?vue&type=script&lang=ts"
import style0 from "./ModalAddRegras.vue?vue&type=style&index=0&id=5caa8046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa8046",
  null
  
)

export default component.exports